import greenWheelPng from '/img/contract/greenwheel.png';
import greenWheelWebp from '/img/contract/greenwheel.webp';
import purpleWheelPng from '/img/contract/purplewheel.png';
import purpleWheelWebp from '/img/contract/purplewheel.webp';

export const wheelImages = {
  green: {
    png: greenWheelPng,
    webp: greenWheelWebp,
  },
  purple: {
    png: purpleWheelPng,
    webp: purpleWheelWebp,
  },
};
